<template>
    <div class="sms-packs">
        <LoaderComponent v-if="loading > 0" />
        <div v-else>
            <div class="row m-0 sms-packs__grid">
                <div class="col-md-6" v-for="(smsPack, index) in smsPacks" :key="index">
                    <div class="sms-pack-card">
                        <div>
                            <span class="sms-pack-card__label">Pack SMS</span>
                            <h6>{{ $t("labels.invoices.smsPack", { nb: smsPack.nb_sms }) }}</h6>
                        </div>
                        <div class="sms-pack-card__price">
                            <strong>{{ smsPack.price_ht / 100 }} € {{ $tl("labels.ht") }}</strong>
                            <small>{{ smsPack.price_ht / 100 / smsPack.nb_sms }} € {{ $tl("labels.ht") }} / {{ $tl("labels.credit") }}</small>
                        </div>
                        <div class="sms-pack-card__action">
                            <button
                                :disabled="isBuyingSmsPack"
                                class="btn btn-sm btn-success btn-circle"
                                @click="displaySmsPackModal(smsPack)"
                                v-tooltip="smsPackTooltip">
                                {{ $tl("labels.form.actions.buy") }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <a href="#" class="sms-packs__link" @click="showInternationalSmsCostModal = true">
                        {{ $tl("infos.sms.foreignCost") }}
                    </a>
                </div>
            </div>
        </div>
        <show-sms-pack-modal v-if="showSmsPackModal" :smsPack="smsPack" @close="showSmsPackModal = false"></show-sms-pack-modal>
        <InternationalSmsCostModal v-if="showInternationalSmsCostModal" @close="showInternationalSmsCostModal = false" />
    </div>
</template>

<script>
import axios from "axios";
import showSmsPackModal from "../Modals/sms/ShowSmsPackModal";
import LoaderComponent from "../LoaderComponent.vue";
import InternationalSmsCostModal from "../Modals/sms/InternationalSmsCostModal";

export default {
    name: "SmsPack",
    data: function () {
        return {
            smsPacks: null,
            smsPack: null,
            showSmsPackModal: false,
            loading: 0,
            showInternationalSmsCostModal: false,
        };
    },
    computed: {
        isBuyingSmsPack() {
            return this.$store.getters["sms/isBuyingPack"];
        },
        lastPaymentMethod() {
            return this.$store.getters["sms/lastPaymentMethod"];
        },
        smsPackTooltip() {
            if (!this.isBuyingSmsPack) {
                return undefined;
            }

            if (this.lastPaymentMethod === "sepa_debit") {
                return { content: this.$t("infos.sms.pendingSmsPackOrderSepa") };
            }

            return { content: this.$t("infos.sms.pendingSmsPackOrder") };
        },
        paymentMethods() {
            return this.$store.getters["stripe/paymentMethods"];
        },
    },
    methods: {
        fetchPacks() {
            this.loading++;

            axios
                .get("/api/smsPack")
                .then((response) => {
                    this.smsPacks = response.data.data;
                })
                .catch((error) => {
                    this.notifyError(error);
                })
                .finally(() => {
                    this.loading--;
                });
        },
        fetchSmsInfo() {
            this.loading++;

            this.$store.dispatch("sms/fetchSmsInfos").finally(() => this.loading--);
        },
        displaySmsPackModal(smsPack) {
            this.$set(this, "smsPack", smsPack);
            this.$nextTick(() => {
                this.showSmsPackModal = true;
            });
        },
    },
    created() {
        this.fetchPacks();
        this.fetchSmsInfo();
    },
    components: {
        showSmsPackModal,
        LoaderComponent,
        InternationalSmsCostModal,
    },
};
</script>

<style scoped>
.sms-packs__grid {
    margin-left: -8px !important;
    margin-right: -8px !important;
}

.sms-packs__grid > [class*="col-"] {
    padding-left: 8px;
    padding-right: 8px;
}

.sms-pack-card {
    height: 100%;
    margin-bottom: 16px;
    padding: 20px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 14px 32px rgba(15, 58, 72, 0.06);
    transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.sms-pack-card:hover {
    transform: translateY(-2px);
    border-color: rgba(48, 164, 183, 0.28);
    box-shadow: 0 18px 42px rgba(15, 58, 72, 0.1);
}

.sms-pack-card__label {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
}

.sms-pack-card h6 {
    margin-bottom: 14px;
    color: #173746;
    font-weight: 700;
}

.sms-pack-card__price {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 18px;
}

.sms-pack-card__price strong {
    color: #142f3c;
    font-size: 1.15rem;
}

.sms-pack-card__price small {
    color: #6c7f88;
}

.sms-pack-card__action {
    display: flex;
    justify-content: flex-end;
}

.sms-packs__link {
    display: inline-flex;
    margin-top: 4px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.9rem;
    font-weight: 600;
}
</style>
